import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import { Dropdown, INPUT_WIDTH } from '@commons/utils/styledLibraryComponents';
import { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';
import WhiteCard from '@commons/WhiteCard';

import InputEmailChip from '@lib/inpulse/InputEmailChip';

import ClientTextInput from '../ClientTextInput';

import { BlockTitle, BlockTitleIcon, FieldsGrid } from '../clientFormStyledComponents';

/**
 * "Informations" block shared by the external-client creation and detail pages: name + associated
 * stores are required, the remaining contact fields are optional. `isReadOnly` renders every field
 * disabled for the consultation mode of the detail page.
 */
const ClientInformationCard = (props) => {
  const {
    name,
    onChangeName,
    stores,
    selectedStores,
    onChangeStores,
    associatedStoresLabel,
    externalReference,
    onChangeExternalReference,
    contact,
    onChangeContact,
    telephone,
    onChangeTelephone,
    contactEmails,
    onChangeContactEmails,
    isReadOnly,
    width,
    maxWidth,
  } = props;

  const renderContent = () => (
    <FieldsGrid>
      <ClientTextInput
        isReadOnly={isReadOnly}
        label={i18next.t('GENERAL.NAME')}
        value={name}
        isRequired
        onChange={onChangeName}
      />
      <Dropdown
        height={'auto'}
        iconSrc={'/images/inpulse/store-black-small.svg'}
        isDisabled={isReadOnly}
        isLabelTextSmall={true}
        isRequired={true}
        isUniqueSelection={false}
        items={stores}
        label={` ${associatedStoresLabel} :`}
        placeholder={i18next.t('GENERAL.CHOOSE_PLACEHOLDER')}
        selectedItems={selectedStores}
        width={INPUT_WIDTH.FULL}
        onSelectionChange={(items) => onChangeStores(items)}
      />
      <ClientTextInput
        isReadOnly={isReadOnly}
        label={i18next.t('EXTERNAL_CLIENTS.CREATION.EXTERNAL_REFERENCE')}
        value={externalReference}
        onChange={onChangeExternalReference}
      />
      <ClientTextInput
        isReadOnly={isReadOnly}
        label={i18next.t('EXTERNAL_CLIENTS.CREATION.CONTACT')}
        value={contact}
        onChange={onChangeContact}
      />
      <ClientTextInput
        isReadOnly={isReadOnly}
        label={i18next.t('GENERAL.PHONE')}
        value={telephone}
        onChange={onChangeTelephone}
      />
      <InputEmailChip
        emails={contactEmails ? contactEmails.split(',') : []}
        isDisabled={isReadOnly}
        placeholder={i18next.t('EXTERNAL_CLIENTS.CREATION.CONTACT_EMAILS')}
        setEmails={onChangeContactEmails}
        title={`${i18next.t('EXTERNAL_CLIENTS.CREATION.CONTACT_EMAILS')} :`}
        titleProperties={{ color: ENUM_COLORS.DARKEST, font: ENUM_FONTS.TEXT_SMALL }}
        width={'100%'}
      />
    </FieldsGrid>
  );

  return (
    <WhiteCard
      maxWidth={maxWidth}
      renderContent={renderContent()}
      title={
        <BlockTitle>
          <BlockTitleIcon src={'/images/inpulse/info-black-small.svg'} />
          {i18next.t('GENERAL.INFORMATIONS')}
        </BlockTitle>
      }
      width={width}
    />
  );
};

ClientInformationCard.propTypes = {
  name: PropTypes.string,
  onChangeName: PropTypes.func.isRequired,
  stores: PropTypes.array,
  selectedStores: PropTypes.array,
  onChangeStores: PropTypes.func.isRequired,
  associatedStoresLabel: PropTypes.string,
  externalReference: PropTypes.string,
  onChangeExternalReference: PropTypes.func.isRequired,
  contact: PropTypes.string,
  onChangeContact: PropTypes.func.isRequired,
  telephone: PropTypes.string,
  onChangeTelephone: PropTypes.func.isRequired,
  contactEmails: PropTypes.string,
  onChangeContactEmails: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
};

ClientInformationCard.defaultProps = {
  name: '',
  stores: [],
  selectedStores: [],
  associatedStoresLabel: '',
  externalReference: '',
  contact: '',
  telephone: '',
  contactEmails: '',
  isReadOnly: false,
  width: '840px',
};

export default ClientInformationCard;
